import { render, staticRenderFns } from "./JcniView.vue?vue&type=template&id=233c090b&scoped=true"
import script from "./JcniView.vue?vue&type=script&lang=js"
export * from "./JcniView.vue?vue&type=script&lang=js"
import style0 from "./JcniView.vue?vue&type=style&index=0&id=233c090b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233c090b",
  null
  
)

export default component.exports